import axios from 'axios';

function normalizeJwt(token) {
    if (!token) return '';

    var t = ('' + token).trim();
    var lower = t.toLowerCase();

    if (lower.indexOf('bearer ') === 0) {
        t = t.substring(7).trim();
    }

    return t;
}

export default function setAuthorizationToken(token) {
    delete axios.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common.authorization;

    var jwt = normalizeJwt(token);

    if (jwt) {
        axios.defaults.headers.common.Authorization = "Bearer " + jwt;
    }
}